import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TextField, InputAdornment, Button, Box } from "@mui/material";

import { isWholeNumber } from "../../utils/helpers";

export const OtpInput = ({
  otp,
  otpHasError,
  setOtp,
  setOtpHasError,
  validateOtp,
}) => {
  const { t } = useTranslation();

  const handleOtpChange = async (e) => {
    const { value } = e.target;
    if (!!value && !isWholeNumber(value)) {
      return;
    } else if (value.length <= 4) {
      if (setOtp) setOtp(value);
      if (otpHasError) setOtpHasError(false);
    }
  };

  return (
    <Box mt={1}>
      {/* <Button
        variant="text"
        sx={{
          minWidth: "36px",
          padding: 0,
          textTransform: "none",
        }}
      >
        {t("resend")}
      </Button> */}
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        label={t("input_label_otp")}
        name="otp"
        value={otp}
        onChange={handleOtpChange}
        error={otpHasError}
        {...(otpHasError ? { helperText: t("error_wrong_otp") } : {})}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  variant="text"
                  sx={{
                    minWidth: "36px",
                    paddingInline: 0,
                    textTransform: "none",
                  }}
                  onClick={validateOtp}
                  disabled={otp.length !== 4}
                >
                  {t("confirm")}
                </Button>
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};
